export const layoutValues = ['grid', 'list'] as const;
export type LayoutType = (typeof layoutValues)[number];

export const sortValues = [
  'name',
  'lastModified',
  'createdAt',
  'draft',
  'version'
] as const;
export type SortType = (typeof sortValues)[number];

export type ActiveOptionsType = {
  layout?: LayoutType;
  sort?: SortType;
  searchText?: string;
  filters?: Record<string, string[]>;
};

export type ContentHeaderContextValue = {
  layout: LayoutType;
  onLayoutChange: (layout: LayoutType) => void;
  handleSelectFilter: (filterKey: string, selected: string[]) => void;
  sort: SortType;
  onSortChange: (sort: SortType) => void;
  searchText: string;
  onInputChange: (value: string) => void;
  searchCallback?: (activeOptions: ActiveOptionsType) => void;
  activeOptions: ActiveOptionsType;
  isLoaded: boolean;
};

type BaseFilterSelectProps = {
  label?: string;
  options: { value: string; label: string }[];
  selectionMode?: 'single' | 'multiple';
  displayCount?: boolean;
  selectionLimit?: number;
  autoApply?: boolean;
  /** Shows a search box above the options that narrows them by label. */
  isSearchable?: boolean;
  /** Called each time the options open, such as to refresh them. */
  onOpen?: () => void;
  className?: string;
  ariaLabel?: string;
  'data-testid'?: string;
};

export type ContextModeProps = BaseFilterSelectProps & {
  standalone?: false;
  filterKey: string;
  onSelect?: (
    selectedKey: string[],
    filterKey: string,
    activeOptions: ActiveOptionsType
  ) => void;
  selectedKey?: never;
  onSelectionChange?: never;
};

export type StandaloneModeProps<T extends string = string> =
  BaseFilterSelectProps & {
    standalone: true;
    selectedKey: T;
    onSelectionChange: (key: T) => void;
    filterKey?: never;
    onSelect?: never;
  };

export type ContentHeaderFilterSelectProps<T extends string = string> =
  ContextModeProps | StandaloneModeProps<T>;
